import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentGiftVoucherPage } from 'src/app/modals/checkout-payment-gift-voucher/checkout-payment-gift-voucher';

const routes: Routes = [
    {
        path: '',
        component: CheckoutPaymentGiftVoucherPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [CheckoutPaymentGiftVoucherPage]
})
export class CheckoutPaymentGiftVoucherPageModule { }
